import { StyledField, StyledGrid, StyledLabel } from '../ui';
import { FormFormattedField, FormInput } from 'components';
import { useCallback, useRef } from 'react';
import { useField, useForm } from 'react-final-form';
import { normalizeFormattedField } from 'utils';
import { useFocusOnRender } from '../hooks';
import { useCounterReserveBalancer } from 'hooks/useCounterReserveBalancer';
import { useIsAlternativeAuction } from 'hooks';
import { Vehicle } from 'types/vehicle';
import { useCounterValidator } from 'hooks/useGetValidators';
import { AUCTION_TYPES } from 'constants';
import { composeValidators } from 'utils/validators';

export const AlternativeOfferField = () => {
  const form = useForm();
  const { values } = form.getState();

  const ref = useRef<HTMLInputElement>(null);
  useFocusOnRender(ref, 'alternative_offer');

  const {
    input: { value: reservePrice, onChange: changeReserve }
  } = useField('reserve_price');

  const {
    input: { value: aaCounter, onChange: changeCounter }
  } = useField('alternative_offer');

  const updateReserve = useCallback((reserve: number) => changeReserve(reserve), []);
  const updateCounter = useCallback((counter: number) => changeCounter(counter), []);

  const isAlternativeAuction = useIsAlternativeAuction(values as Vehicle);

  useCounterReserveBalancer(Number(reservePrice) || 0, Number(aaCounter) || 0, updateReserve, updateCounter, {
    skip: !isAlternativeAuction || values.in_battle || values?.reserve_price_met
  });

  const auctionType = values.auction?.type || AUCTION_TYPES.AUTOAXESS;
  const validateAlternativeOffer = useCounterValidator(auctionType);

  return (
    <StyledGrid item xs={12}>
      <StyledLabel>Counter to buyers</StyledLabel>
      <StyledField
        name="alternative_offer"
        component={FormFormattedField}
        inputRef={ref}
        placeholder=""
        // @ts-ignore
        thousandSeparator
        allowNegative={false}
        fixedDecimalScale
        prefix="$"
        customInput={FormInput}
        disableUnderline
        parse={normalizeFormattedField}
        validate={composeValidators(...validateAlternativeOffer)}
        disabled={values.in_battle}
      />
    </StyledGrid>
  );
};
